import useReveal from "../../hooks/useReveal";
import CourtIcon from "../CourtIcon";

const sports = [
	{
		title: "Tennis",
		description: "Track your tennis matches with comprehensive scoring and statistics.",
		highlight: "Professional Scoring",
	},
	{
		title: "Padel",
		description: "Keep score of your padel games with specialized rules and point tracking.",
		highlight: "Specialized Rules",
	},
	{
		title: "Badminton",
		description: "Monitor your badminton matches with detailed point-by-point tracking.",
		highlight: "Point Tracking",
	},
	{
		title: "Pickleball",
		description: "Track your pickleball games with dedicated scoring and statistics.",
		highlight: "Custom Scoring",
	},
	{
		title: "Ping Pong",
		description: "Keep track of your table tennis matches with precise scoring and match statistics.",
		highlight: "Match Analytics",
	},
	{
		title: "Squash",
		description: "Record your squash games with detailed point tracking and performance metrics.",
		highlight: "Performance Metrics",
	},
];

function SportCard({ sport, index, isDark }) {
	const ref = useReveal(index);
	return (
		<div ref={ref} className="reveal lift">
			<div
				className="h-24 flex items-center justify-center p-4"
				style={{
					background: isDark ? "var(--color-night-2)" : "var(--color-paper-2)",
					border: `var(--rule-fine) solid ${isDark ? "var(--color-night-rule)" : "var(--color-rule-2)"}`,
					borderBottom: "none",
					color: "var(--color-accent)",
				}}
				aria-hidden="true"
			>
				<div className="w-full h-full max-w-[160px]">
					<CourtIcon sport={sport.title} />
				</div>
			</div>
			<div
				className="p-6"
				style={{
					border: `var(--rule-fine) solid ${isDark ? "var(--color-night-rule)" : "var(--color-rule-2)"}`,
					borderTop: "none",
				}}
			>
				<p
					className="font-display font-bold uppercase mb-2"
					style={{ fontSize: "var(--text-xs)", letterSpacing: "var(--tracking-label)", color: "var(--color-accent)" }}
				>
					{sport.highlight}
				</p>
				<h3
					className="font-display font-bold mb-2"
					style={{ fontSize: "var(--text-xl)", color: isDark ? "var(--color-on-night)" : "var(--color-ink)" }}
				>
					{sport.title}
				</h3>
				<p
					style={{
						fontSize: "var(--text-sm)",
						lineHeight: "var(--lh-body)",
						color: isDark ? "var(--color-on-night-muted)" : "var(--color-muted)",
					}}
				>
					{sport.description}
				</p>
			</div>
		</div>
	);
}

const SportsSection = ({ isDark }) => {
	const headRef = useReveal(0);
	const surface = isDark ? "var(--color-night)" : "var(--color-paper)";
	const ink = isDark ? "var(--color-on-night)" : "var(--color-ink)";
	const muted = isDark ? "var(--color-on-night-muted)" : "var(--color-muted)";

	return (
		<section id="sports" className="py-20 md:py-28" style={{ background: surface }}>
			<div className="container mx-auto px-4 sm:px-6">
				<div ref={headRef} className="reveal text-center mb-16 max-w-2xl mx-auto">
					<p
						className="font-display font-bold uppercase mb-3"
						style={{ fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)", color: "var(--color-accent)" }}
					>
						One app, every court
					</p>
					<h2
						className="font-display font-bold uppercase"
						style={{
							fontSize: "var(--text-display-s)",
							lineHeight: "var(--lh-tight)",
							letterSpacing: "var(--tracking-display)",
							color: ink,
							overflowWrap: "anywhere",
						}}
					>
						Supported Sports
					</h2>
					<p className="mt-4" style={{ fontSize: "var(--text-lg)", color: muted }}>
						Track your performance across multiple racket sports.
					</p>
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
					{sports.map((sport, index) => (
						<SportCard key={sport.title} sport={sport} index={index} isDark={isDark} />
					))}
				</div>
			</div>
		</section>
	);
};

export default SportsSection;
